// extracted by mini-css-extract-plugin
export default {"autoplay":"AutoplayToggle-module__autoplay_iTH8d","label":"AutoplayToggle-module__label_IrTHI"};